"use strict";

require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBAPIsSection;
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
var _SVBAPICards = require("../../../react-organisms/SVBAPICards");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SVBAPISection Component
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * to render API Section
 */
// import { Link } from 'react-router-dom';

/**
 * Parameters
 * 
 * @param apiCardsData - objects holds all the data for eg:
 *   const apiCardsData = {
 *   carousel: true, //boolean
 *   apiSectionlabel: "Heading for entire API section"
 *   apisJson: JsondataFromBrowse,
 *   cardSlide: 3, //number of cards per slide
 *   viewAll: '/api/docs-home',
    }
 * to render API section in different pages
 */
function SVBAPIsSection(props) {
  const {
    apiCardsData
  } = props;
  const cardsSectionOption = apiCardsData.cardsOption;
  // const carouselViewAll = cardsSectionOption && cardsSectionOption.viewAll && (
  //   <div className='viewall-btn' data-testid={apiCardsData.apiSectionlabe + '-' + 'view-all'}>
  //     {cardsSectionOption.viewAllLink ? (
  //       <SVBButton
  //         text='All APIs'
  //         size='large'
  //         style='primary'
  //         state='default'
  //         type='text'
  //         icon='right-arrow'
  //         iconSide='right'
  //         onClick={() => (window.location.href = cardsSectionOption.viewAllLink)}
  //       />
  //     ) : (
  //       <SVBButton
  //         text='All APIs'
  //         size='large'
  //         style='primary'
  //         state='default'
  //         type='text'
  //         icon='right-arrow'
  //         iconSide='right'
  //         onClick={() => (window.location.href = 'apis/docs-home')}
  //       />
  //     )}
  //   </div>
  // );

  const finalClass = cardsSectionOption.extraClasses ? cardsSectionOption.extraClasses + ' wrapper-apis-section my-3' : 'wrapper-apis-section my-3';
  const cardJsonData = apiCardsData.apisJson.map(obj => _objectSpread(_objectSpread({}, obj), {}, {
    api_description: obj.api_description.length > 256 ? obj.api_description.slice(0, 256) + '...' : obj.api_description
  })); //limit characters in carousel or api cards o 256char
  return /*#__PURE__*/_react.default.createElement("div", {
    className: finalClass
  }, apiCardsData.apiSectionlabel && /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: "heading-large"
  }, apiCardsData.apiSectionlabel), cardsSectionOption && cardsSectionOption.carousel ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SVBAPICards.SVBAPICardsCarousel, {
    apisJson: cardJsonData,
    slide: cardsSectionOption.cardSlide ? cardsSectionOption.cardSlide : '3',
    cardOptions: cardsSectionOption.cardOptions,
    apiCardsData: apiCardsData
    // viewAll={carouselViewAll ? carouselViewAll : null}
  })) : /*#__PURE__*/_react.default.createElement(_SVBAPICards.SVBAPICards, {
    apisJson: cardJsonData,
    cardOptions: cardsSectionOption.cardOptions
  }));
}